module.exports = __webpack_public_path__ + "img/vip-tag-diamond.4c24cc70.png";